export const insertGoogleRecaptcha = (sitekey?: string) => {
  if (!sitekey) {
    return;
  }
  (function (w: Window, d: Document, i: string) {
    const head = d.getElementsByTagName('head')[0];
    const script = d.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${sitekey}`;

    head?.appendChild(script);
  })(window, document, sitekey);
};
